
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.13 8.25a7.266 7.266 0 11-14.531 0 7.266 7.266 0 0114.53 0zm-8.106 3.847l5.39-5.39a.469.469 0 000-.663l-.662-.663a.469.469 0 00-.663 0L6.692 9.777 4.64 7.724a.469.469 0 00-.663 0l-.663.663a.469.469 0 000 .663l3.047 3.047c.183.183.48.183.663 0z","fill":"#45C20B"}})])
          )
        }
      }
    